import React from 'react';

const features = [
  { icon: '🧮', title: 'Bomkalkulator', desc: 'Beregn nøyaktige bomkostnader for enhver rute i Norge. Støtter alle kjøretøytyper inkludert EV og hybrid med automatisk rabattberegning.', accent: '#FF5722' },
  { icon: '🗺️', title: 'Ruteoptimalisering', desc: 'Finn den billigste og raskeste ruten automatisk. Vår algoritme analyserer sanntids trafikkdata og bompriser for optimal planlegging.', accent: '#004F98' },
  { icon: '📊', title: 'Kostnadsrapporter', desc: 'Detaljerte månedlige rapporter over dine bomutgifter. Eksporter til regnskapssystem og følg med på utgiftsutviklingen over tid.', accent: '#FF5722' },
  { icon: '🔔', title: 'Sanntidsvarsler', desc: 'Motta øyeblikkelige varsler om trafikkforhold, vegarbeid og prisendringer via SMS eller push-notifikasjoner.', accent: '#004F98' },
  { icon: '🚗', title: 'Flåtestyring', desc: 'Administrer opptil 50 kjøretøy fra ett dashbord. Perfekt for bedrifter med firmabiler og transportflåter.', accent: '#FF5722' },
  { icon: '🔒', title: 'Norsk sikkerhet', desc: 'Sertifisert etter norske og europeiske sikkerhetsstandarder. Dine data lagres kryptert på norske servere.', accent: '#004F98' },
];

const FeaturesSection = () => (
  <section id="features" className="features-section-padding" style={{ position: 'relative', padding: '120px 48px', background: 'var(--color-background)', overflow: 'hidden' }}>
    {/* Background geometry */}
    <div style={{ position: 'absolute', inset: 0, pointerEvents: 'none' }}>
      <div style={{ position: 'absolute', top: '10%', left: '-100px', width: '400px', height: '400px', border: '1px solid rgba(255,87,34,0.06)', transform: 'rotate(-15deg)' }} />
      <div style={{ position: 'absolute', bottom: '5%', right: '-60px', width: '300px', height: '300px', border: '1px solid rgba(0,79,152,0.08)', transform: 'rotate(10deg)' }} />
    </div>
    <div style={{ maxWidth: '1440px', margin: '0 auto', position: 'relative', zIndex: 1 }}>
      {/* Section header — asymmetric */}
      <div className="features-header-grid" style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: '60px', alignItems: 'flex-end', marginBottom: '80px' }}>
        <div>
          <div style={{ display: 'inline-block', background: 'rgba(0,79,152,0.1)', border: '1px solid rgba(0,79,152,0.2)', borderRadius: '2px', padding: '4px 12px', marginBottom: '20px' }}>
            <span style={{ fontFamily: 'var(--font-heading)', fontSize: '11px', fontWeight: 600, letterSpacing: '0.14em', textTransform: 'uppercase', color: '#004F98' }}>Funksjoner</span>
          </div>
          <h2 style={{ fontFamily: 'var(--font-heading)', fontSize: 'clamp(28px, 4vw, 42px)', fontWeight: 700, color: 'var(--color-foreground)', lineHeight: 1.1, letterSpacing: '-0.01em' }}>
            Alt du trenger
            <span style={{ display: 'block', color: '#FF5722' }}>på én plattform</span>
          </h2>
        </div>
        <p style={{ fontFamily: 'var(--font-body)', fontSize: '16px', fontWeight: 500, color: 'var(--color-muted-foreground)', lineHeight: 1.7, paddingBottom: '8px' }}>
          Veiassistent samler alle verktøy for norsk veiplanlegging i én intuitiv løsning — fra enkle bomberegninger til avansert flåtestyring for bedrifter.
        </p>
      </div>

      {/* Feature grid — staggered */}
      <div className="features-grid" style={{ display: 'grid', gridTemplateColumns: 'repeat(3, 1fr)', gap: '2px' }}>
        {features?.map((f, i) => (
          <div
            key={f?.title}
            className="feature-card-stagger"
            style={{
              padding: '40px 36px',
              background: i % 2 === 0 ? 'rgba(255,255,255,0.02)' : 'rgba(255,255,255,0.01)',
              border: '1px solid rgba(224,228,232,0.06)',
              position: 'relative',
              marginTop: i % 3 === 1 ? '32px' : '0',
              transition: 'background 200ms ease',
            }}
          >
            <div style={{ position: 'absolute', top: 0, left: 0, width: '3px', height: '40px', background: f?.accent, opacity: 0.6 }} />
            <div style={{ fontSize: '32px', marginBottom: '20px' }}>{f?.icon}</div>
            <h3 style={{ fontFamily: 'var(--font-heading)', fontSize: '20px', fontWeight: 600, color: 'var(--color-foreground)', marginBottom: '12px', letterSpacing: '0.01em' }}>{f?.title}</h3>
            <p style={{ fontFamily: 'var(--font-body)', fontSize: '14px', fontWeight: 500, color: 'var(--color-muted-foreground)', lineHeight: 1.7 }}>{f?.desc}</p>
          </div>
        ))}
      </div>
    </div>
  </section>
);

export default FeaturesSection;
